import React from 'react';
import Logo from '../components/common/Logo';
import { User, Search, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import DoctorSidebar from '../components/dashboard-doctor/DoctorSidebar';

const DoctorMessagesPage = () => {
  const navigate = useNavigate();
  
  const conversations = [
    {
      id: 1,
      patient: "Mario Rossi",
      lastMessage: "Grazie dottore per la seduta di oggi. Volevo chiederle se...",
      timestamp: "10:30",
      unread: true,
      nextAppointment: "15 Nov 2024",
      totalSessions: 5
    },
    {
      id: 2,
      patient: "Laura Bianchi",
      lastMessage: "Confermo l'appuntamento per martedì prossimo alle 15:00",
      timestamp: "Ieri",
      unread: false,
      nextAppointment: "12 Nov 2024",
      totalSessions: 3
    },
    {
      id: 3,
      patient: "Giuseppe Verdi",
      lastMessage: "Ho completato gli esercizi che mi ha assegnato...",
      timestamp: "Ieri",
      unread: false,
      nextAppointment: "20 Nov 2024",
      totalSessions: 8
    }
  ];

  const handleChatClick = (id) => {
    navigate(`/doctor/messages/${id}`);
  };

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <DoctorSidebar />
      </div>

      {/* Main content */}
      <div className="flex-1 bg-[#FAF4EB]">
        <div className="h-full flex flex-col">
          {/* Header */}
          <header className="bg-white p-4 shadow-sm">
            <h1 className="text-2xl font-bold mb-4">Messaggi Pazienti</h1>
            <div className="relative">
              <input
                type="text"
                placeholder="Cerca nelle conversazioni..."
                className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
              <Search className="absolute left-3 top-2.5 text-gray-400 w-5 h-5" />
            </div>
          </header>

          {/* Conversations list */}
          <div className="flex-1 overflow-y-auto">
            {conversations.map((conv) => (
              <div
                key={conv.id}
                onClick={() => handleChatClick(conv.id)}
                className={`flex items-center p-4 border-b hover:bg-gray-50 cursor-pointer ${
                  conv.unread ? 'bg-purple-50' : 'bg-white'
                }`}
              >
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                  <User className="w-6 h-6 text-purple-600" />
                </div>

                <div className="flex-1 ml-4">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="font-semibold">{conv.patient}</h3>
                      <p className="text-sm text-gray-500">
                        Prossimo appuntamento: {conv.nextAppointment}
                      </p>
                    </div>
                    <div className="text-right">
                      <div className="flex items-center">
                        <Clock className="w-4 h-4 text-gray-400 mr-1" />
                        <span className="text-sm text-gray-500">{conv.timestamp}</span>
                      </div>
                      <span className="text-xs text-purple-600">
                        {conv.totalSessions} sedute
                      </span>
                    </div>
                  </div>
                  <p className={`text-sm mt-1 ${conv.unread ? 'font-semibold' : 'text-gray-600'}`}>
                    {conv.lastMessage}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorMessagesPage;